import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '@htx/environment';
import { evaluateAccess } from './access-check';

export const connectorAdminGuard: CanActivateFn = () => {
  if (!environment.oauth) {
    return true;
  }
  const oauthService = inject(OAuthService);
  if (!oauthService.hasValidAccessToken()) {
    return false;
  }
  const result = evaluateAccess(oauthService.getAccessToken(), environment.oauth);
  return result.allowed;
};
